import React, { Component } from 'react'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Map from '../../assets/mics/pic.jpg'
class ImageZoomPanPich extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // MODAL
      imgWidth: null, imgHeight: null, x: 0, y: 0, downX: 0, downY: 0, scalingFactor: 1

    }
  }
  onImgLoad = ({ target: img }) => {
    // const { scalingFactor } = this.state;
    const imageWidth = img.width;
    const imageHeight = img.height;
    // console.log(imageWidth)
    // console.log(imageHeight)
    this.setState({
      imgWidth: imageWidth,
      imgHeight: imageHeight,
    })
  }
  handleZoomChange = (e) => {
    console.log(e);
    var { scalingFactor } = this.state;
    this.state.scalingFactor = e.scale;
    console.log(scalingFactor)



  }
  handleMouseMove = (e) => {
    const { scalingFactor } = this.state;
    console.log(scalingFactor)
    const layerX = e.nativeEvent.layerX;
    const layerY = e.nativeEvent.layerY;

    this.setState({
      x: layerX * scalingFactor, y: layerY * scalingFactor,
    });
  }
  handleMouseDown = (e) => {
    const { scalingFactor } = this.state;
    const { layerX, layerY } = e.nativeEvent

    let downX = this.state.downX;
    let downY = this.state.downY;

    downX = layerX * scalingFactor;
    downY = layerY * scalingFactor;
    console.log(downX, downY);
    this.setState({
      downX, downY,
    });


  }
  render() {
    const { x, y, downX, downY, scalingFactor } = this.state;
    const primaryPointer = <circle cx={x / scalingFactor} cy={y / scalingFactor} r={4} fill="black" />
    const downPointer = <circle cx={downX / scalingFactor} cy={downY / scalingFactor} r={5} fill="blue" />
    const scaledGridSize = 20 / scalingFactor;

    const grid = (

      <React.Fragment>
        <defs>
          <pattern id="transformedPattern" x="0" y="0" width={scaledGridSize} height={scaledGridSize} patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width={scaledGridSize} height={scaledGridSize} className="grid-rect" />
          </pattern>
        </defs>
        <rect x="0" y="0" width="100%" height="100%" className="shapes-svg" />
      </React.Fragment>

    );
    return (
      <TransformWrapper
        onZoomChange={(e) => { this.handleZoomChange(e) }}

      >


        <React.Fragment>

          <div style={{ margin: '100px', border: '0px solid', width: this.state.imgWidth }} onMouseMove={this.handleMouseMove} onMouseDown={this.handleMouseDown}>
            <TransformComponent >
              <div style={{ height: '500px' }}>
                <img src={Map} alt="test" onLoad={this.onImgLoad} style={{ height: '500px', border: "0px solid red" }} />
              </div>
              <div className="sketch-box sketch-stack-top">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={this.state.imgWidth}
                  height={this.state.imgHeight}
                >
                  {/* DRAW GRID */}

                  {grid}
                  {primaryPointer}

                </svg>
              </div>
            </TransformComponent>
          </div>
        </React.Fragment>
      </TransformWrapper>
    )
  }
}

export default ImageZoomPanPich
